import React from 'react';
import { CheckCircleFilled, InfoCircleFilled, SafetyCertificateFilled } from '@ant-design/icons';

interface TabDef {
  label: string;
  key: string;
  reportType: string;
}

interface Props {
  tabs: TabDef[];
  reports: Record<string, { status?: number } | undefined>;
  activeKey: string;
  onChange: (key: string) => void;
}

const ReportTabsBar: React.FC<Props> = ({ tabs, reports, activeKey, onChange }) => {
  return (
    <div style={{ display: 'flex', gap: 16, marginBottom: 24 }}>
      {tabs.map((tab) => {
        const report = reports[tab.reportType];
        const isSuccess = report?.status === 4 || report?.status === 5;
        const isActive = activeKey === tab.key;

        let btnStyle: React.CSSProperties = {
          flex: 1,
          height: 60,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          borderRadius: 6,
          cursor: 'pointer',
          transition: 'all 0.3s',
          border: 'none',
          outline: 'none',
          position: 'relative',
          padding: '0 8px',
        };

        let icon: React.ReactNode = null;
        let labelStyle: React.CSSProperties = { fontSize: 13 };

        if (isActive) {
          btnStyle = { ...btnStyle, background: 'linear-gradient(135deg, #1d39c4 0%, #2f54eb 100%)', color: '#fff' };
          labelStyle = { ...labelStyle, fontWeight: 'bold' };
          icon = <CheckCircleFilled style={{ fontSize: 18, marginRight: 6 }} />;
        } else if (isSuccess) {
          btnStyle = { ...btnStyle, background: '#4096ff', color: '#fff' };
          icon = <SafetyCertificateFilled style={{ fontSize: 18, marginRight: 6 }} />;
        } else {
          btnStyle = { ...btnStyle, background: '#fff', border: '1px solid #87e8de', color: '#8c8c8c', cursor: 'not-allowed' };
          icon = <InfoCircleFilled style={{ fontSize: 18, marginRight: 6, color: '#d9d9d9' }} />;
        }

        return (
          <div style={{ flex: 1, position: 'relative' }} key={tab.key}>
            <div
              style={btnStyle}
              onClick={() => {
                if (isSuccess) onChange(tab.key);
              }}
            >
              <div style={{ display: 'flex', alignItems: 'center' }}>
                {icon}
                <span style={labelStyle}>{tab.label}</span>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default ReportTabsBar;

